import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Assignment from "@material-ui/icons/Assignment";

// core components
import CardTable from "components/CardTable/CardTable";

// config Table
import { configTable } from "./tableData";

import {
  setConfigBrandsStationFilter,
  setConfigBrandsStationPage,
  setConfigBrandsStationPageSize,
  setConfigBrandsStationSorted,
} from "redux/ducks/brandsSection";
import { convertToMapById } from "helpers/convertToMap";
import { validateObject } from "helpers/validateObject";

const BrandStation = () => {
  let history = useHistory();
  const dispatch = useDispatch();

  const { brands, station } = useSelector(state => state.brandsReducer)
  const { stations } = useSelector(state => state.companies)
  const [mapBrands, setMapBrands] = useState([])
  const [filterBrands, setFilterBrands] = useState([])

  useEffect(() => {
    setMapBrands( convertToMapById(brands) )
  }, [brands])

  useEffect(() => {
    if(validateObject(station) && mapBrands.length > 0) {
      setFilterBrands( mapBrands.filter(brand => brand.idStation === station.id).map(brandM => {
        return {
          ...brandM,
          stationName: stations[brandM.idStation].label
        }
      }) )
    } else if(mapBrands.length > 0){
      setFilterBrands( mapBrands.map(brandM => {
        return {
          ...brandM,
          stationName: stations[brandM.idStation]?.label || stations[brandM.idStation]?.name
        }
      }) )
    }
  }, [mapBrands, brands, stations, station])

  // selectors
  const { page, pageSize, sorted } = useSelector(
    (state) => state.brandsSection.config.brandsStation
  );

  const handleChangePage = (page) => {
    const newDirection = page ? page : "/admin/nuevo_marca_planta";
    history.push(newDirection);
  };

  // calls
  const handleChangeBrandsStationFilteredMemoized = useCallback(
    (event) => {
      dispatch(setConfigBrandsStationFilter(event));
    },
    [dispatch]
  );
  const handleChangeBrandsStationPageMemoized = useCallback(
    (event) => {
      dispatch(setConfigBrandsStationPage(event));
    },
    [dispatch]
  );
  const handleChangeBrandsStationPageSizeMemoized = useCallback(
    (event) => {
      dispatch(setConfigBrandsStationPageSize(event));
    },
    [dispatch]
  );
  const handleChangeBrandsStationSortedMemoized = useCallback(
    (event) => {
      dispatch(setConfigBrandsStationSorted(event));
    },
    [dispatch]
  );

  return (
    <CardTable
      hasHeader
      title="Marcas por planta"
      icon={<Assignment />}
      data={filterBrands}
      page={page}
      sorted={sorted}
      pageSize={pageSize}
      onChangePage={handleChangePage}
      columns={configTable}
      previousText="Anterior"
      nextText="Siguiente"
      noDataText="Sin datos"
      pageText="Pagina"
      ofText="de"
      resizable={false}
      rowsText="marcas"
      onPageChange={handleChangeBrandsStationPageMemoized}
      onPageSizeChange={handleChangeBrandsStationPageSizeMemoized}
      onSortedChange={handleChangeBrandsStationSortedMemoized}
      onFilteredChange={handleChangeBrandsStationFilteredMemoized}
    />
  );
};

export default BrandStation;
